/*
 *
 * MyOrders reducer
 *
 */

import { fromJS } from 'immutable';
import {
  DEFAULT_ACTION,
  FETCH_ORDERS,
  CANCEL_ORDER,
  RETURN_ORDER,
} from './constants';

const initialState = fromJS({
  orders: {},
  isLoading: false,
  cancelOrder: {},
  returnOrder: { status: false },
});

function myOrdersReducer(state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case DEFAULT_ACTION:
      return state.set('isLoading', payload);
    case FETCH_ORDERS:
      return state
        .set('orders', fromJS(payload))
        .set('isLoading', false);
    case CANCEL_ORDER:
      return state
        .set('cancelOrder', fromJS(payload.orders));
    case RETURN_ORDER:
      return state
        .set('returnOrder', fromJS(payload))
        .set('isLoading', false);
    default:
      return state;
  }
}

export default myOrdersReducer;



// WEBPACK FOOTER //
// client/containers/MyOrders/reducer.js